//#region src/shared/component-sizes.ts
var e = {
	xs: {
		height: "h-6",
		heightPx: 24,
		paddingX: "px-2",
		textSize: "text-xs",
		iconSize: 12
	},
	sm: {
		height: "h-7",
		heightPx: 28,
		paddingX: "px-2",
		textSize: "text-sm",
		iconSize: 14
	},
	default: {
		height: "h-8",
		heightPx: 32,
		paddingX: "px-3",
		textSize: "text-base",
		iconSize: 16
	},
	lg: {
		height: "h-10",
		heightPx: 40,
		paddingX: "px-3",
		textSize: "text-md",
		iconSize: 20
	}
};
function t(t = "default") {
	let n = e[t];
	return `${n.height} ${n.paddingX} ${n.textSize}`;
}
function n(t = "default") {
	return `${e[t].textSize} ${t === "lg" ? "py-2.5" : t === "default" ? "py-2" : t === "sm" ? "py-1.5" : "py-1"}`;
}
function r(t = "default") {
	return `${e[t].textSize} ${t === "lg" ? "h-11" : t === "default" ? "h-10" : t === "sm" ? "h-9" : "h-8"}`;
}
function i(t = "default") {
	let n = e[t];
	return `${n.textSize} ${n.paddingX} ${t === "lg" || t === "default" ? "py-2" : t === "sm" ? "py-1.5" : "py-1"}`;
}
var a = "max-h-[min(480px,60vh)]";
//#endregion
export { a as COMBOBOX_DROPDOWN_LIST_MAX_HEIGHT_CLASS, e as COMPONENT_SIZES, r as comboboxDropdownInputClasses, n as comboboxDropdownItemClasses, t as formControlSizeClasses, i as textareaSizeClasses };
